import DetailNotifyPartnerAdmin from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin/DetailNotifyPartnerAdmin';
import TopPageNotifyDetailPartnerAdmin from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin/TopPageNotifyDetailPartnerAdmin';
import TopPagePartnerAdmin from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin/TopPagePartnerAdmin';
import TopPageProductDetailPartnerAdmin from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin/TopPageProductDetailPartnerAdmin';
import TopPageProductSuperDetailPartnerAdmin from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin/TopPageProductSuperDetailPartnerAdmin';
import { Outlet } from 'react-router-dom';

const TopPageProductPartnerAdmin = () => {
  return <Outlet />;
};

export default TopPageProductPartnerAdmin;

export {
  DetailNotifyPartnerAdmin,
  TopPageNotifyDetailPartnerAdmin,
  TopPagePartnerAdmin,
  TopPageProductDetailPartnerAdmin,
  TopPageProductSuperDetailPartnerAdmin,
};
